import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';
import { FiCheckCircle, FiXCircle, FiLoader } from 'react-icons/fi';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }

    const verify = async () => {
      try {
        // Appel au backend pour valider le token
        await api.post('/auth/verify-email', { token });
        setStatus('success');
        // Redirection automatique vers le login après 5 secondes
        setTimeout(() => navigate('/login'), 5000);
      } catch (error) {
        console.error("Erreur de vérification:", error);
        setStatus('error');
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        {status === 'verifying' && (
          <>
            <FiLoader className="mx-auto h-16 w-16 text-brand-blue animate-spin mb-6" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Vérification en cours...</h2>
            <p className="text-gray-500">Veuillez patienter un instant.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
              <FiCheckCircle className="h-10 w-10 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Email vérifié !</h2>
            <p className="text-gray-600 mb-6">Votre compte a été activé avec succès. Vous allez être redirigé vers la page de connexion.</p>
            <Link to="/login" className="text-brand-blue font-bold hover:underline">Aller à la connexion maintenant</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
              <FiXCircle className="h-10 w-10 text-red-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Échec de la vérification</h2>
            <p className="text-gray-600 mb-6">Le lien de vérification est invalide ou a expiré.</p>
            <div className="flex flex-col space-y-3">
              <Link to="/resend-verification" className="bg-brand-blue text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors">Renvoyer un lien</Link>
              <Link to="/login" className="text-gray-500 hover:text-gray-700 font-medium">Retour à la connexion</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
